import { cn } from '@rocco/utils/cn';
import { useUserLoggedIn } from '~/modules/user/hook/use-user';
import { SectionSpacer } from '~/ui-rocco/pages/home-page/components/SectionSpacer';
import { CONTENT_CAP } from './large-screen';
import { IslandFreeClosing } from './IslandFreeClosing';
// Imported by path rather than through the details-page barrel: that barrel also
// pulls the product page's sections, and the resulting cycle leaves the binding
// undefined at module-eval time.
import { JoinArchiProSection } from '~/ui-rocco/pages/details-page/revamp/sections/JoinArchiProSection';

/**
 * The sign-up band every revamped detail page closes on: a full-width rule with
 * 100px of air either side, then the band, then a matching 100px out to the
 * footer. The rule closes off the page's content — the product page gets that
 * line from its accordion, but a page ending in a grid or a gallery has nothing
 * to end on. Replaces the older editorial closing (the homepage hero / intro /
 * feature strip), which repeated the homepage at the end of every page.
 *
 * `bg-white` backs the whole block so a dark page never shows through the
 * sub-pixel seams between fixed-aspect sections as stray lines, and the
 * Magic Island blanks across the whole run: the page has stopped talking
 * about the item by here, so the enquiry pill has nothing left to act on.
 *
 * The band is the whole block — the rule and the air exist to frame it — so
 * a member, who has no account to create, gets none of it and the page runs
 * straight from its last section into the footer.
 */
export const JoinArchiProClosing = () => {
    const { isLoggedIn } = useUserLoggedIn();
    if (isLoggedIn) return null;

    return (
        <IslandFreeClosing className="bg-white">
            <SectionSpacer
                height={100}
                mobileHeight={64}
                className="bg-white"
                unit="rem"
            />
            {/* Capped to the band below it, so the two share an edge. */}
            <div className="bg-white max-md:px-4 md:px-0">
                <div className={cn(CONTENT_CAP, 'h-px bg-black/10')} />
            </div>
            <SectionSpacer
                height={100}
                mobileHeight={64}
                className="bg-white"
                unit="rem"
            />
            <JoinArchiProSection />
            <SectionSpacer
                height={100}
                mobileHeight={64}
                className="bg-white"
                unit="rem"
            />
        </IslandFreeClosing>
    );
};
